<template>
  <div class="page rsvp">
    
    <top-bar />

    <div :style="{ 
      padding: '40px',
      color: colors.paleYellow,
      backgroundColor: colors.indigoDark
      }">
      <rsvp-form
        :fg="colors.tanDark"
        :bg="colors.tan"
        />
    </div>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue'
import RsvpForm from '@/components/RsvpForm'
import { colors } from '@/colors.js'

export default {
  name: 'Rsvp',
  components: {
      RsvpForm,
      TopBar,
  },
  data () {
    return {
      colors
    }
  },
}
</script>
